import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { PUBLIC_HOST } from "../../lib/domain";

const FIELDS = [
  ["j2", "J-2 avant le premier cours (+ équipement)"],
  ["after", "Lendemain du premier cours"],
  ["impaye", "Familles NON payées — lien d'inscription / paiement (relance tous les 7 jours, max 3)"],
];

export function CommsPanel() {
  const [open, setOpen] = useState(false);
  const [cfg, setCfg] = useState(null);
  const [vars, setVars] = useState([]);
  const [preview, setPreview] = useState(null);
  const [run, setRun] = useState(null);

  useEffect(() => {
    if (!open || cfg) return;
    api.get("/samourais/comms/config").then((r) => { setCfg(r.data.config); setVars(r.data.variables || []); }).catch(() => toast.error("Erreur"));
  }, [open, cfg]);

  const save = async () => {
    try { const r = await api.put("/samourais/comms/config", cfg); setCfg(r.data.config); toast.success("Modèles enregistrés"); }
    catch { toast.error("Erreur"); }
  };
  const doPreview = async (kind) => {
    try { const r = await api.get(`/samourais/comms/preview?kind=${kind}`); setPreview({ kind, ...r.data }); } catch { toast.error("Erreur"); }
  };
  const dryRun = async () => {
    try { const r = await api.post("/samourais/comms/run-now"); setRun(r.data); toast.info(`Aujourd'hui : ${r.data.preview.length} envoi(s) prévu(s) (aperçu, rien envoyé)`); } catch { toast.error("Erreur"); }
  };

  return (
    <div className="mb-6 rounded-2xl border border-white/10 bg-white/[0.03]" data-testid="ps-comms-panel">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between px-4 py-3 text-sm font-semibold" data-testid="ps-comms-toggle">
        <span>📨 Communications automatiques (J-2 premier cours · lendemain du 1er cours · rappel familles non payées)</span>
        <span className="text-zinc-400">{open ? "▲" : "▼"}</span>
      </button>
      {open && cfg && (
        <div className="px-4 pb-4 space-y-3">
          <div className="flex flex-wrap items-center gap-3 text-xs">
            <label className="flex items-center gap-2"><input type="checkbox" checked={!!cfg.enabled} onChange={(e) => setCfg({ ...cfg, enabled: e.target.checked })} data-testid="ps-comms-enabled" /> Envoi automatique activé (vérifié chaque jour à 14h UTC · J-2 et lendemain : familles payées, une fois par dossier)</label>
            <label className="flex items-center gap-2"><input type="checkbox" checked={cfg.impaye_enabled !== false} onChange={(e) => setCfg({ ...cfg, impaye_enabled: e.target.checked })} data-testid="ps-comms-impaye-enabled" /> Rappel familles non payées (lien {PUBLIC_HOST}/inscription) · tous les <input type="number" min="1" value={cfg.impaye_every_days ?? 7} onChange={(e) => setCfg({ ...cfg, impaye_every_days: Number(e.target.value) })} className="w-12 rounded bg-zinc-900 border border-white/10 px-1 py-0.5 text-center" data-testid="ps-comms-impaye-every" /> j · max <input type="number" min="1" value={cfg.impaye_max ?? 3} onChange={(e) => setCfg({ ...cfg, impaye_max: Number(e.target.value) })} className="w-12 rounded bg-zinc-900 border border-white/10 px-1 py-0.5 text-center" data-testid="ps-comms-impaye-max" /> envois</label>
            <span className="text-zinc-500">Variables : {vars.join(" ")}</span>
          </div>
          {FIELDS.map(([k, label]) => (
            <div key={k} className="rounded-xl border border-white/10 p-3 space-y-2" data-testid={`ps-comms-${k}`}>
              <div className="flex items-center justify-between"><b className="text-sm">{label}</b><button onClick={() => doPreview(k)} className="text-xs text-sky-300 underline" data-testid={`ps-comms-preview-${k}`}>Aperçu rendu</button></div>
              <input value={cfg[`${k}_subject`]} onChange={(e) => setCfg({ ...cfg, [`${k}_subject`]: e.target.value })} className="w-full rounded-lg bg-zinc-900 border border-white/10 p-2 text-sm" data-testid={`ps-comms-${k}-subject`} />
              <textarea value={cfg[`${k}_body`]} onChange={(e) => setCfg({ ...cfg, [`${k}_body`]: e.target.value })} className="w-full min-h-[110px] rounded-lg bg-zinc-900 border border-white/10 p-2 text-xs" data-testid={`ps-comms-${k}-body`} />
              <input value={cfg[`${k}_sms`]} onChange={(e) => setCfg({ ...cfg, [`${k}_sms`]: e.target.value })} className="w-full rounded-lg bg-zinc-900 border border-white/10 p-2 text-xs" placeholder="SMS" data-testid={`ps-comms-${k}-sms`} />
            </div>
          ))}
          {preview && (
            <div className="rounded-xl border border-emerald-500/30 bg-emerald-500/5 p-3 text-xs whitespace-pre-line" data-testid="ps-comms-preview-box">
              <div className="text-emerald-300 font-semibold mb-1">Aperçu {preview.kind} {preview.sample ? `— famille ${preview.sample}` : "(variables brutes)"}</div>
              <div><b>Objet :</b> {preview.rendered.subject}</div>
              <div className="mt-1">{preview.rendered.body}</div>
              <div className="mt-2 text-zinc-400"><b>SMS :</b> {preview.rendered.sms}</div>
            </div>
          )}
          {run && <div className="text-xs text-zinc-300" data-testid="ps-comms-run-result">Aperçu du jour ({run.date}) : {run.preview.length} envoi(s) — {run.preview.map((p) => `${p.kind} → ${p.child}`).join(", ") || "aucun"}</div>}
          <div className="flex gap-2 justify-end">
            <button onClick={dryRun} className="text-xs border border-white/15 rounded-lg px-3 py-1.5" data-testid="ps-comms-dryrun">🔍 Qui recevrait aujourd'hui ?</button>
            <button onClick={save} className="text-xs bg-amber-500 text-black font-semibold rounded-lg px-3 py-1.5" data-testid="ps-comms-save">💾 Enregistrer</button>
          </div>
        </div>
      )}
    </div>
  );
}
